import { MoreHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const PRIMARY_BTN = "flex items-center gap-2 bg-primary hover:bg-primary/90 text-white font-medium px-4 py-2 rounded-xl text-sm shadow-sm transition-colors disabled:opacity-50";
export const SECONDARY_BTN = "flex items-center gap-2 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 font-medium px-3.5 py-2 rounded-xl text-sm transition-colors disabled:opacity-50";

function ActionButton({ action, className }) {
  const Icon = action.icon;
  return (
    <button type="button" onClick={action.onClick} disabled={action.disabled} data-testid={action.testId} className={className}>
      {Icon && <Icon className="w-4 h-4" />}
      {action.label}
    </button>
  );
}

// 1 action principale + actions secondaires + menu « Plus d'actions » (actions moins fréquentes / sensibles).
export default function PatientActionToolbar({ primary, secondary = [], more = [], extra = null }) {
  const visibleMore = more.filter(Boolean);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="patient-action-toolbar">
      {primary && <ActionButton action={primary} className={PRIMARY_BTN} />}
      {secondary.filter(Boolean).map((a) => <ActionButton key={a.testId} action={a} className={SECONDARY_BTN} />)}
      {extra}
      {visibleMore.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button type="button" data-testid="patient-more-actions-btn" className={`${SECONDARY_BTN} ml-auto`}>
              <MoreHorizontal className="w-4 h-4" />
              Plus d'actions
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-60 bg-white" data-testid="patient-more-actions-menu">
            {visibleMore.map((a, i) => {
              const Icon = a.icon;
              return (
                <div key={a.testId}>
                  {a.separatorBefore && i > 0 && <DropdownMenuSeparator />}
                  <DropdownMenuItem onSelect={a.onClick} disabled={a.disabled} data-testid={a.testId}
                    className={`gap-2 cursor-pointer ${a.danger ? "text-rose-700 focus:text-rose-700 focus:bg-rose-50" : ""}`}>
                    {Icon && <Icon className="w-4 h-4" />}
                    {a.label}
                  </DropdownMenuItem>
                </div>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
